module.exports = __webpack_public_path__ + "static/img/ban2.1c527ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/ban2.jpg
// module id = t1TH
// module chunks = 55